import React, { memo } from "react";
import "./NewsChannel.css";
import { useHistory } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import useCommonQuery from "../../../store/common/useCommonQuery";
import ShareIcon from "@mui/icons-material/Share";

const NewsChannel = () => {
  const history = useHistory();

  const { data: newsChannelList } = useCommonQuery.Get_channel({
    limit: 30,
    offset: 0,
  });
  const handleShare = async () => {
    try {
      await navigator.share({
        url: `https://masterclick.in/news-channel`,
      });
    } catch (error) { }
  };
  return (
    <div className="news-channel-container">
      {/* Header bar */}
      <div className="news-channel-header">
        <div className="news-channel-header-inner">
          <ArrowBackIcon
            onClick={() => history.push("/")}
            style={{
              color: "black",
              cursor: "pointer"
            }}
          />
          <Typography style={{ color: "black", fontSize: "18px", fontWeight: "600" }}>
            NewsChannel
          </Typography>
        </div>
      </div>

      {/* Main body centered */}
      <div className="news-channel-body">
        <div className="news-title-row">
          <div className="news-head">മലയാളം വാർത്താ ചാനലുകൾ</div>
          <div className="channel-button-class" onClick={handleShare}>
            <ShareIcon />
          </div>
        </div>

        {/* Fluid responsive Grid */}
        <div className="news-channel-grid">
          {newsChannelList &&
            newsChannelList.data.results.map((item, idx) => (
              <a
                key={idx}
                href={item?.url ? item?.url : ""}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className="news-channel-card">
                  <img
                    className="news-channel-logo"
                    src={item.image}
                    alt={item.name}
                  />
                </div>
              </a>
            ))}
        </div>
      </div>
    </div>
  );
}

export default memo(NewsChannel);
